// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomYoutubeShorts = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 12 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.2387 6.84911C9.99177 6.70949 9.75556 6.55916 9.47649 6.39811C9.75556 6.22635 10.0134 6.07601 10.2603 5.93639C11.4091 5.31362 12.0425 4.04684 11.8492 2.75846C11.5699 0.643579 9.13279 -0.580176 7.28627 0.471818C5.39672 1.5563 3.50717 2.61918 1.63905 3.73563C0.157475 4.62675 -0.0573142 5.80766 0.178901 7.20335C0.329236 8.07304 0.908974 8.71706 1.67119 9.15735C1.93954 9.30769 2.19718 9.45802 2.48714 9.62978C2.16504 9.82297 1.87526 9.99473 1.56388 10.1558C0.189615 11.0255 -0.282817 12.8075 0.490284 14.2463C1.30624 15.7601 3.19579 16.3399 4.7095 15.5239C6.34141 14.6007 7.97331 13.6558 9.59451 12.7111C9.98106 12.4856 10.389 12.2817 10.7326 12.0025C12.4611 10.5638 12.2034 7.95502 10.2387 6.84911ZM4.47346 10.3706V5.67892L8.5318 8.01948L4.47346 10.3706Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomYoutubeShorts };
